import styled from "styled-components";
import SelectAutoWidth from "../../components/SelectAutoWidth";

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(235, 235, 240, 1);
  border-radius: 10px;
  height: 40px;
  width: auto;
  padding-inline: 8px;
  transition: width 0.3s ease-in-out;
`;

export const Label = styled.label`
  font-size: 14px;
  margin-left: 8px;
  font-family: Open Sans;
  font-weight: 600;
  white-space: nowrap;
  width: max-content;
  align-self: center;
  background-color: var(
    --Color-Tokens-Background-Light,
    rgba(255, 255, 255, 1)
  );
  transition: width 0.3s ease-in-out;
`;

export const SelectInternal = styled(SelectAutoWidth)`
  font-size: 14px;
  border: none;
  outline: none;
  font-family: Open Sans;
  font-weight: 400;
  color: var(--Color-Tokens-Content-Dark-Secondary, rgba(114, 114, 114, 1));
  transition: width 0.3s ease-in-out;
`;
